import { render, staticRenderFns } from "./payment-type-argentea.vue?vue&type=template&id=99656414"
import script from "./payment-type-argentea.vue?vue&type=script&lang=js"
export * from "./payment-type-argentea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports